<template> 
	<!-- 提示错误,可自动关闭 -->
	<div v-if="errorInfo && errorInfo.msg" class="posi-fixed modelErrMsg-box"> 
		<P v-if="errorInfo.type == 'fail'"><img src="../../assets/img/fail.png"></P>
		<P v-else><img src="../../assets/img/success.png"></P>
		<p>{{errorInfo.msg}}</p>
	</div>
</template>

<script>
	export default{ //msg,okUrl,ccUrl,okTxt,ccTxt,strTitle
		inheritAttrs:false,//根元素不继承特性
		mounted(){
			
		},
		computed:{
			errorInfo(){
				return this.$store.state.errorInfo;
			}
		},
		data(){
			return{
				 
			}
		},		 
	}
</script>

<style scoped lang="less">
	.modelErrMsg-box {
		top:10%;
		left:50%;
		min-width:10rem;
		padding:.8rem 1.5rem;
		transform: translateX(-50%);
		box-shadow: 0 0 .5rem .1rem #d1d1d1;
		text-align: center;
		font-size: .75rem;
		background: rgba(0,0,0,.8);
		z-index: 9999999;
		p{
			img{
				width:1.8rem;
				height:1.8rem;
			}
			font-size: .8rem;
			color:#fff;
			font-family:HiraginoSansGB-W3;
		}
		p:last-child{
			padding:.5rem 0 .1rem;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/publicCpts/modelErrMsgCpt.vue